/**
 * True for Mobile Safari / iPadOS Safari only (not Brave, Chrome, Firefox, etc. on iOS).
 * Used so scanline `bottom` can add env(safe-area-inset-bottom) only where needed.
 */
export function isIosStockSafari() {
  if (typeof navigator === "undefined") {
    return false;
  }
  const ua = navigator.userAgent;

  const isIOS =
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  if (!isIOS) {
    return false;
  }

  if (
    /CriOS|FxiOS|EdgiOS|OPiOS|OPT\/|Brave\/|DDG\/|DuckDuckGo|GSA\/|Line\/|FBAN|FBAV|Instagram|Twitter/i.test(
      ua,
    )
  ) {
    return false;
  }

  if (!/Safari\//.test(ua) || !/Version\//.test(ua)) {
    return false;
  }

  if (/CriOS/.test(ua)) {
    return false;
  }

  return true;
}
